import pager from '@apps-common/js-client/api/pager';
import request from '@apps-common/js-client/api/request';

import {
  BASEMAP_RULES_URL,
  MOSAICS_ENDPOINT,
  SERIES_ENDPOINT,
} from '@explorer/config';

export const getMosaicById = async mosaicId => {
  return await request
    .get(`${MOSAICS_ENDPOINT}/${mosaicId}`, {
      params: {
        v: '1.5',
      },
    })
    .then(res => res.data);
};

export const getMosaicByName = async mosaicName => {
  return await request
    .get(`${MOSAICS_ENDPOINT}`, {
      params: {
        v: '1.5',
        name__is: mosaicName,
      },
    })
    .then(res => res.data.mosaics[0]);
};

export const getMosaicsForSeries = async seriesId => {
  return await request
    .get(`${SERIES_ENDPOINT}/${seriesId}/mosaics`, {
      params: {
        v: '1.5',
      },
    })
    .then(res => res.data.mosaics);
};

export const getSeries = onEach => {
  const config = {
    url: SERIES_ENDPOINT,
    params: {
      _page_size: 1000,
    },
    retries: 3,
  };

  return pager(config, 'series', onEach);
};

export const getMosaicRules = async () => {
  return await request
    .get(`${BASEMAP_RULES_URL}`, {
      params: {
        v: 1,
        e: 'json',
      },
    })
    .then(response => response.data);
};
